import { DialogType } from '@tableau/widgets';
import React = require('react');
import * as _ from 'underscore';
import { SetSiteUsersRoleDialog } from '../components/SetSiteUsersRoleDialog';
import { CommonStyles } from '../../common/react/CommonStyles';
import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { Set } from '../../ts/models/Set';
import { Module } from '../../ts/Module';
import { ModalInstance, ReactModalService } from '../../ts/services/ReactModalService';

const SetSiteUsersRoleDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: CommonStyles.Sizes.MediumSpace,
  paddingLeft: CommonStyles.Sizes.MediumSpace,
  paddingRight: CommonStyles.Sizes.MediumSpace
};

function showSetSiteUsersSiteRoleDialog(siteUsersToSet: Set<ISiteUserInfo>) {
  let modalInstance: ModalInstance<unknown>;
  const dialogProps = {
    close: () => modalInstance && modalInstance.close({}),
    dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
    siteUsersToSet: siteUsersToSet
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(SetSiteUsersRoleDialog, dialogProps),
    testId: 'setSiteUsersRoleDialog',
    showCloseButton: true,
    dialogStyle: SetSiteUsersRoleDialogStyle,
    shouldNotSetDefaultWidth: true
  });
  return modalInstance.result;
}

export const SetSiteUsersSiteRoleAction = {
  showSetSiteUsersSiteRoleDialog
};
